/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {GraphZoneElement} from './GraphZoneElement';
import {
  GraphZoneElementFromJSON,
  GraphZoneElementFromJSONTyped,
  GraphZoneElementToJSON
} from './GraphZoneElement';
import type {EdgesInner} from './EdgesInner';
import {EdgesInnerFromJSON, EdgesInnerFromJSONTyped, EdgesInnerToJSON} from './EdgesInner';

/**
 *
 * @export
 * @interface GraphZone
 */
export interface GraphZone {
  /**
   *
   * @type {Array<EdgesInner>}
   * @memberof GraphZone
   */
  edges?: Array<EdgesInner>;
  /**
   *
   * @type {Array<GraphZoneElement>}
   * @memberof GraphZone
   */
  nodes?: Array<GraphZoneElement>;
}

/**
 * Check if a given object implements the GraphZone interface.
 */
export function instanceOfGraphZone(value: object): value is GraphZone {
  return true;
}

export function GraphZoneFromJSON(json: any): GraphZone {
  return GraphZoneFromJSONTyped(json, false);
}

export function GraphZoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): GraphZone {
  if (json == null) {
    return json;
  }
  return {
    edges:
      json['edges'] == null ? undefined : (json['edges'] as Array<any>).map(EdgesInnerFromJSON),
    nodes:
      json['nodes'] == null
        ? undefined
        : (json['nodes'] as Array<any>).map(GraphZoneElementFromJSON)
  };
}

export function GraphZoneToJSON(value?: GraphZone | null): any {
  if (value == null) {
    return value;
  }
  return {
    edges:
      value['edges'] == null ? undefined : (value['edges'] as Array<any>).map(EdgesInnerToJSON),
    nodes:
      value['nodes'] == null
        ? undefined
        : (value['nodes'] as Array<any>).map(GraphZoneElementToJSON)
  };
}
